import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import {
    MatSnackBarRef,
    MAT_SNACK_BAR_DATA
} from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { INotificationResponseModel } from 'src/app/modules/notifications/interfaces/notification-response-model';
import { NotificationService } from 'src/app/modules/notifications/services/notification.service';

@Component({
    selector: 'app-notification-popup',
    templateUrl: './notification-popup.component.html',
    styleUrls: ['./notification-popup.component.scss'],
    encapsulation: ViewEncapsulation.None // Allow for control of the css snackbar class properly
})
export class NotificationPopupComponent implements OnInit {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA)
        public notification: INotificationResponseModel,
        public snackBarRef: MatSnackBarRef<NotificationPopupComponent>,
        private router: Router,
        private route: ActivatedRoute,
        private notificationService: NotificationService
    ) {}

    ngOnInit() {}

    public navigateToUri(event: Event): void {
        this.readNotification(event);
        this.router.navigate([this.notification.uri], {
            relativeTo: this.route
        });
    }

    public readNotification(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        this.notificationService.readNotification(
            this.notification.notificationId
        );

        this.snackBarRef.dismiss();
    }
}
